import React,{ useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ProjectActionTypes } from '../../redux/project/project.types';
import { DefinitionsActionTypes } from '../../redux/definitions/definitions.types';
import GreenLine from '../../components/greenline/greenline.component';
import { removeFirstChar } from '../../utils/utils';

import 'antd/dist/antd.css';
import './baslangic.page.styles.scss';

class Baslangic extends React.Component{

  constructor(props){
    super(props);
    this.state = {
    };
  }

  componentDidMount(){
    console.log(this.props.language);
    
    this.props.setCurrent(removeFirstChar(this.props.language.routes.baslangic));
    window.scrollTo(0,0);
  }

  goTo = (event,type) => {
    event.preventDefault();
    this.props.setCurrent('step-1');
    return this.props.history.push(this.props.language.routes.signup+'/step-1');    
  }  


  render(){
    return(
      <React.Fragment>
        <div className="baslangicWrapperNew">
            <GreenLine />
            <div className="baslangicContentWrapper">
              <div className="baslangicContent">
                <p className="baslangicYazi">
                  {this.props.language.keywords.merhaba}!
                </p>
                <p>
                  {this.props.language.keywords.baslangicAciklama}
                </p>
                <p>
                <strong>{this.props.language.keywords.adim1Title} :</strong> {this.props.language.keywords.adim1Text}
                </p>
                <p>
                <strong>{this.props.language.keywords.adim2Title} : </strong> {this.props.language.keywords.adim2Text}
                </p>
                <p>
                <strong>{this.props.language.keywords.adim3Title} : </strong> {this.props.language.keywords.adim3Text}
                </p> 
                <p>
                <strong>{this.props.language.keywords.adim4Title} : </strong> {this.props.language.keywords.adim4Text}
                </p>  
                <p>
                <strong>{this.props.language.keywords.adim5Title} : </strong> {this.props.language.keywords.adim5Text}
                </p>           
                <p>
                  {this.props.language.keywords.hosgeldiniz}!
                </p>  
                <button className="btnWeb btnFilterSearch btnBaslaNew" onClick={(event) => this.goTo(event)}>{this.props.language.keywords.basla}</button>
              </div>
            </div>
      </div>
      
    </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    step1: state.definitions.step1,
    warningMessage: state.project.warningMessageText,
    warningType: state.project.warningMessageType,
    currentPage: state.project.currentPage,
    language: state.project.language
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onWarning: (payload) => dispatch({ type: ProjectActionTypes.SET_WARNING_MESSAGE, payload: payload}),
    setDefault: () => dispatch({ type: ProjectActionTypes.SET_DEFAULT}),
    setStep1: (step1) => dispatch({ type: DefinitionsActionTypes.SET_STEP1, step1: step1}),
    setCurrent: (value) => dispatch({type: ProjectActionTypes.SET_CURRENT, value: value })
  }
}




export default connect(mapStateToProps,mapDispatchToProps)(withRouter(Baslangic));